module.exports = __webpack_public_path__ + "img/HUN.3636e0a3.svg";